export function getGsheetURL(spreadsheet_id, sheet_id) {
  const url = `https://docs.google.com/spreadsheets/d/${spreadsheet_id}/edit#gid=${sheet_id}`;
  return url;
}

export function openGsheet(spreadsheet_id) {
  const url = getGsheetURL(spreadsheet_id);
  const new_window = window.open();
  new_window.location.href = url;
}



// WEBPACK FOOTER //
// ./src/components/gsheet/URL.js